import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from '../brand/Logo';
import { navItems } from '../../data/site';
export function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);
  return <header className="sticky top-0 z-50 bg-cream/95 backdrop-blur" data-id="element-171" data-mp="lyqgo3xelo1k">
      <div className="hidden border-b border-ink/10 bg-cream-deep text-ink-soft md:block" data-id="element-172" data-mp="i0iz56v48ipb">
        <div className="mx-auto flex max-w-shell items-center justify-between px-8 py-2 text-[0.6875rem] uppercase tracking-label" data-id="element-173" data-mp="vro2aixozt4e">
          <p data-id="element-174" data-mp="qyl4fylvtxie">Clinically directed care · Licensed in all 50 states</p>
          <p className="text-brick" data-id="element-175" data-mp="39a5mmo3ed6w">Membership from $39/mo · Price held 12 months</p>
        </div>
      </div>

      <div className="mx-auto max-w-shell px-6 md:px-8" data-id="element-176" data-mp="3ug3f0dt1himi">
        <div className="flex items-center justify-between py-5" data-id="element-177" data-mp="6vyhrvr7jufu">
          <Link to="/" className="text-ink" aria-label="Republic home" data-id="element-178" data-mp="6tkl5igvqa66">
            <Logo className="text-base md:text-lg" data-id="element-179" data-mp="bt6z5u4j7ug1" />
          </Link>

          <nav aria-label="Primary" className="hidden items-center gap-7 lg:flex" data-id="element-180" data-mp="gl86r2qr8wzq">
            {navItems.map(item => <NavLink key={item.to} to={item.to} className={({
            isActive
          }) => `text-sm transition-colors duration-150 ease-republic ${isActive ? 'text-brick' : 'text-ink-soft hover:text-ink'}`} data-id="element-181" data-mp="lj9rrt7qr6du">
                {item.label}
              </NavLink>)}
          </nav>

          <div className="hidden items-center gap-6 lg:flex" data-id="element-182" data-mp="1xwyb9pvdt3u">
            <Link to="/pricing" className="text-sm text-ink-soft transition-colors duration-150 ease-republic hover:text-ink" data-id="element-183" data-mp="19axctuibnn87">
              Sign in
            </Link>
            <Link to="/get-started" className="bg-brick px-6 py-3 text-sm font-medium text-cream transition-colors duration-150 ease-republic hover:bg-brick-deep" data-id="element-184" data-mp="3abbuut4k4l7n">
              Start intake
            </Link>
          </div>

          <button type="button" onClick={() => setOpen(value => !value)} className="text-ink lg:hidden" aria-expanded={open} aria-label={open ? 'Close menu' : 'Open menu'} data-id="element-185" data-mp="3ee8bwfeg899h">
            {open ? <XIcon className="h-6 w-6" data-id="element-186" data-mp="2moncy7fjssr1" /> : <MenuIcon className="h-6 w-6" data-id="element-187" data-mp="30e7amyu9uzth" />}
          </button>
        </div>
        <div className="rule" data-id="element-188" data-mp="30ga8u65kvz9a" />
      </div>

      <AnimatePresence data-id="element-189" data-mp="2vmyyhv1k50cm">
        {open && <motion.div initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="overflow-hidden border-b border-ink/10 bg-cream lg:hidden" data-id="element-190" data-mp="2vm5zxhcr5h5k">
            <nav aria-label="Mobile" className="mx-auto max-w-shell px-6 py-6" data-id="element-191" data-mp="ieoc0817m5a6">
              <ul className="flex flex-col" data-id="element-192" data-mp="n8sh0lqx038m">
                {navItems.map(item => <li key={item.to} className="border-b border-ink/10" data-id="element-193" data-mp="9hnpk6xpah9d">
                    <Link to={item.to} className="block py-4 font-serif text-2xl text-ink" data-id="element-194" data-mp="eee60vdf3evb">
                      {item.label}
                    </Link>
                  </li>)}
              </ul>
              <Link to="/get-started" className="mt-6 inline-flex bg-brick px-6 py-3 text-sm font-medium text-cream" data-id="element-195" data-mp="165bs3gla417t">
                Start intake
              </Link>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}